import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";

const AddTwoFieldsModal = ({ title, onSubmit, fieldLabels }) => {
  const route = all_routes;
  const [fieldOne, setFieldOne] = useState("");
  const [fieldTwo, setFieldTwo] = useState("");

  const handleFormSubmit = () => {
    if (onSubmit) {
      onSubmit(fieldOne, fieldTwo);
    }
    setFieldOne("");
    setFieldTwo("");
  };

  return (
    <>
      {/* Add Two Fields Modal */}
      <div
        className="modal fade"
        id="add-two-fields-modal"
        data-bs-backdrop="false"
        style={{ height: window.height }}>
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Add New {title ? title : ""}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <div className="mb-3">
                    <label className="form-label">{fieldLabels?.[0] || "Field 1"}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={fieldOne}
                      onChange={(e) => setFieldOne(e.target.value)}
                    />
                  </div>
                  {/* as the backend expects a 3 character code
                  the input should be limited to 3 characters
                  update made by Zaman */}
                  <div className="mb-3">
                    <label className="form-label">{fieldLabels?.[1] || "Field 2"}</label>
                    <input
                      type="text"
                      maxLength={3}
                      className="form-control"
                      value={fieldTwo}
                      onChange={(e) => setFieldTwo(e.target.value)}
                    />
                  </div>
                  <div className="modal-footer-btn">
                    <Link to="#" className="btn btn-cancel me-2" data-bs-dismiss="modal">
                      Cancel
                    </Link>
                    <Link
                      to={route.addproduct}
                      className="btn btn-submit"
                      onClick={handleFormSubmit}
                      data-bs-dismiss="modal">
                      Submit
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Two Fields Modal */}
    </>
  );
};

export default AddTwoFieldsModal;
